import { AdditionalQualifier } from '../../models/table-state.model'

export class DynamicTableState {
  // public filterValues: {[key: string]: any} = {};
  public filterValues: DynamicTableStateItem[] = []
  public additionalQualifier: AdditionalQualifier
  public selectedRow?: any
  public currentFirst?: number
  public currentRowsPerPage?: number
}

export class DynamicTableStateItem {
  value: any
  key: string
  matchMode: string
  constructor(key: string, value: any, matchMode: string) {
    this.key = key
    this.value = value
    this.matchMode = matchMode
  }
}
